import React from 'react'
import {Link} from 'gatsby'

const Sidebar = () => {
    return (
        <div>
            {/* <Link to="/stay-informed" className="btn-block btn btn-action btn-lg" >
            STAY INFORMED
            </Link> */}
            <Link to="/volunteer" className="btn-block btn btn-action btn-lg" >
          PARTICIPATE
        </Link>
        <Link to="/donate" className="btn-block btn btn-action btn-lg" >
          DONATE
        </Link>    
        </div>
    )
}

export default Sidebar